<template>
  <div class="app_box">
    <div class="app_title">{{ $t("gameinfo.exploit.setting") }}</div>
    <div class="xian"></div>
    <div class="loading_box" v-if="!appSecret"><loading></loading></div>
    <div class="app" v-else>
      <div class="basic">
        <div class="BASIC MG_t53">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              {{ $t("gameinfo.exploit.sdk") }}
            </div>
            <div class="time_text CU">
              <span @click="copy(appId)">{{ appId }}</span>
            </div>
          </div>
        </div>

        <!-- <div class="BASIC MG_t53">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px;">{{ $t('gameinfo.exploit.status') }}</div>
            <div class="time_text">{{ state[baseInfo.version] }}</div>
          </div>
        </div> -->

        <div class="BASIC MG_t53">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              {{ $t("gameinfo.exploit.datatoken") }}
            </div>
            <div class="time_text">
              <span @click="copy(appSecret.dataToken)">*************</span>
              <span
                class="CU showbtn showSecret"
                @click="copy(appSecret.dataToken)"
                >{{ $t("gameinfo.exploit.copy") }}</span
              >
            </div>
            <div class="init_title">
              {{ $t("gameinfo.exploit.dataTokeninfo") }}
            </div>
          </div>
        </div>

        <div class="BASIC MG_t53">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT" style="line-height: 40px">
              {{ $t("gameinfo.exploit.sdkinfo") }}
            </div>
            <div class="time_text CU">
              {{ $t("gameinfo.exploit.text") }}
              <span @click="opensdk" class="showbtn">{{
                $t("gameinfo.exploit.text1")
              }}</span>
            </div>
            <div class="init_title">
              <!--  -->
              {{ $t("gameinfo.exploit.email") }}
              <span class="CU showbtn" @click="copy(configs)"
                >{{ configs }} ({{ $t("gameinfo.exploit.copy") }})</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import loading from "@/components/loading/loading.vue";
import configs from "@/utils/config.js";
export default {
  components: {
    loading,
  },
  data() {
    return {
      configs: configs.serviceEmail(),
      state: this.$t("gameinfo.exploit.state"),
      appId: this.$route.query.appId,
      gameId: this.$route.query.gameId,
      appSecret: "",
    };
  },
  created() {
    if (!this.GameAppInfo) {
      this.load();
    } else {
      this.vuexLoad();
    }
  },
  mounted() {
    // 获取密钥
    this.initSecret();
  },
  computed: {
    ...mapState("game", ["baseInfo"]),
  },
  methods: {
    ...mapActions("game", ["GetGameAuth", "getGameDeveloperInfo"]),
    async initSecret() {
      const res = await this.GetGameAuth({
        $axios: this.$axios,
        appId: this.appId,
        gameId: this.gameId,
      });
      console.log("GetGameAuth", res);
      if (res.code == 200) {
        this.appSecret = res.data.secret;
        this.appId = res.data.appId;
      }
    },
    vuexLoad() {},

    async load() {
      var res = await this.getGameDeveloperInfo({
        $axios: this.$axios,
        gameId: this.gameId,
      });
      console.log("res", res);
    },
    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(this.$t("gameinfo.exploit.copysuccess"));
      // this.$message({
      //   message: '复制成功',
      //   type: 'success'
      // });
      oInput.remove();
    },
    // 点击跳转SDK
    opensdk() {
      window.open(this.$t("config.h5tgadoc"));
    },
  },
};
</script>

<style scoped="scoped">
.app_box {
  width: 100%;
  min-height: 422px;
}
.app_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}

.app {
  margin-top: 31px;
  /* padding-left: 50px; */
}
.app .basic {
  padding-left: 175px;
}

.material_box {
  display: flex;
}
.time_text {
  height: 40px;
  line-height: 40px;
}
.MG_t53 {
  margin-top: 53px;
}
.showSecret {
  margin-left: 30px;
  font-size: 14px;
}
.showbtn {
  color: #4990fa;
}
.init_title {
  font-size: 12px;
  color: #b0b0b0;
}
.init_text {
}
.loading_box {
  height: 422px;
}
</style>



// WEBPACK FOOTER //
// src/components/games/gameinfo/Exploit_settings/basic.vue